import React, { FunctionComponent, SVGAttributes } from 'react';
import { Svg } from '../../SvgOptimizer/Svg';

const Twotone: FunctionComponent<SVGAttributes<SVGSVGElement>> = (props) => (
  <Svg optimizationId="iconsContentCopyTwotone" viewBox="0 0 24 24" {...props}>
    <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1z" />
    <path opacity={0.3} d="M8 7v14h11V7z" />
    <path d="M8 7v14h11V7H8zm0-2h11a2 2 0 012 2v14a2 2 0 01-2 2H8a2 2 0 01-2-2V7a2 2 0 012-2z" />
  </Svg>
);

Twotone.displayName = 'ContentCopyTwotone';

export default Twotone;
